import ColoredElement from "../ui/ColoredElement";
import Heading from "../ui/Heading";
import MediaWrap from "../ui/MediaWrap";

export default function Banner({ data }) {
  const { element, media, contentBlock } = data;

  return (
    <section className="ob-banner">
      <div className="ob-columnar">
        <ColoredElement params={element} />

        <Heading params={contentBlock} />

        <MediaWrap params={media} />
      </div>
    </section>
  );
}
